
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const SortControls = ({ totalResults, currentSort, onSortChange }) => {
  const sortOptions = [
    { value: 'relevance', label: 'Most Relevant' },
    { value: 'date-desc', label: 'Newest First' },
    { value: 'date-asc', label: 'Oldest First' },
    { value: 'salary-desc', label: 'Highest Salary' },
    { value: 'salary-asc', label: 'Lowest Salary' },
    { value: 'company-rating', label: 'Top Rated Companies' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-2">
          <Icon name="Search" size={20} className="text-muted-foreground" />
          <p className="text-sm text-foreground">
            <span className="font-semibold">{totalResults?.toLocaleString('en-IN')}</span>
            <span className="text-muted-foreground ml-1">jobs found</span>
          </p>
        </div>

        <div className="flex items-center gap-3">
          <label className="text-sm text-muted-foreground whitespace-nowrap hidden sm:block">
            Sort by:
          </label>
          <div className="w-full sm:w-64">
            <Select
              options={sortOptions}
              value={currentSort}
              onChange={onSortChange}
              placeholder="Sort by"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SortControls;